import React from 'react';
import cn from 'clsx';
import PropTypes from 'prop-types';

import Collapsible from '../../../../library/collapsible/collapsible';

import { ChildrenProp } from '../../../../shared/utils/prop-types/prop-types';

import styles from './category-collapsible.scss';

function CategoryCollapsible(props) {
  const { children, description, isOpenByDefault, label, toggleType } = props;

  return (
    <div className={cn(styles['container'], 'category-collapsible')}>
      <Collapsible
        description={description}
        isOpenByDefault={isOpenByDefault}
        label={label}
        toggleType={toggleType}
      >
        {children}
      </Collapsible>
    </div>
  );
}

export default CategoryCollapsible;

CategoryCollapsible.propTypes = {
  children: ChildrenProp,
  description: PropTypes.string,
  isOpenByDefault: PropTypes.bool,
  label: PropTypes.string,
  toggleType: PropTypes.string
};
